import { InjectionToken } from '@angular/core';
import type { DatadogRumLoader } from './models';

export const DATADOG_RUM_LOADER = new InjectionToken<DatadogRumLoader>(
    'Datadog RUM loader',
    {
        providedIn: 'root',
        factory: () => async () => {
            const { getRumClient } = await import('./rum.adapter');
            return getRumClient();
        },
    }
);
